import React, {useEffect, useRef, useState} from 'react';
import {socket} from '../../../socket';
import {fetchMessagesAPI, sendMessageAPI} from '../../../zustand/API';

const ChatWindow = ({chat, currentUserEmail}) => {
	const [messages, setMessages] = useState([]);
	const [text, setText] = useState('');
	const bottomRef = useRef();

	const fetchMessages = async () => {
		try {
			const msgs = await fetchMessagesAPI(chat._id);
			setMessages(msgs);
			socket.emit('join', chat._id);
		} catch (err) {
			console.error('Error fetching messages:', err.message);
		}
	};

	useEffect(() => {
		fetchMessages();
	}, [chat._id]);

	useEffect(() => {
		const handleNewMessage = ({chatId, message}) => {
			if (chatId === chat._id && message) {
				setMessages((prev) => [...prev, message]);
			}
		};

		socket.on('newMessage', handleNewMessage);
		return () => socket.off('newMessage', handleNewMessage);
	}, [chat._id]);

	useEffect(() => {
		bottomRef.current?.scrollIntoView({behavior: 'smooth'});
	}, [messages]);

	const sendMessage = async () => {
		if (!text.trim()) return;
		const message = {text, senderEmail: currentUserEmail};
		try {
			await sendMessageAPI(chat._id, message);
			socket.emit('message', {
				chatId: chat._id,
				message,
				participants: chat.participants,
			});
			setText('');
		} catch (err) {
			console.error('Error sending message:', err.message);
		}
	};

	return (
		<div className="flex flex-col h-full bg-gray-50">
			<div className="flex-1 overflow-y-auto p-4 space-y-2">
				{messages.map((m, i) => {
					const isSender = (m.senderEmail || m.sender) === currentUserEmail;
					return (
						<div
							key={i}
							className={`flex ${isSender ? 'justify-end' : 'justify-start'}`}
						>
							<div
								key={i}
								className={`flex w-full ${
									isSender ? 'justify-end' : 'justify-start'
								}`}
							>
								<div
									className={`px-4 py-2 rounded-2xl text-sm max-w-[70%] shadow bg-white break-all whitespace-pre-wrap overflow-wrap break-word ${
										isSender ? 'bg-green-100' : 'bg-white'
									}`}
									style={{wordBreak: 'break-word'}}
								>
									{m.text}
								</div>
							</div>
						</div>
					);
				})}
				<div ref={bottomRef} />
			</div>

			<div className="flex p-3 border-t bg-white">
				<input
					value={text}
					onChange={(e) => setText(e.target.value)}
					onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
					placeholder="Type a message..."
					className="flex-1 px-4 py-2 text-sm border border-gray-300 rounded-full outline-none mr-2"
				/>
				<button
					onClick={sendMessage}
					disabled={!text.trim()}
					className="bg-indigo-600 hover:bg-indigo-500 text-white px-4 py-2 rounded-full text-sm disabled:opacity-50"
				>
					Send
				</button>
			</div>
		</div>
	);
};

export default ChatWindow;
